// extracted by mini-css-extract-plugin
export var cardHeader = "_gn-0";
export var reorderHandle = "_gn-3";
export var titleArea = "_gn-1";
export var titleAreaWithHandle = "_gn-2";